import React from 'react'
import { useParams } from 'react-router-dom'

export default function CostCode() {
    const { id } = useParams()

    console.log(id, 'data <==========')
    return (
        <>
            <div>CostCode</div>
        </>
    )
}
